import { PropostaTab } from "./types/proposta";
import { usePropostaForm } from "./context/PropostaFormContext";

const tabs: {
  id: PropostaTab;
  label: string;
  mobileLabel: string;
}[] = [
  { id: "proponentes", label: "Proponentes", mobileLabel: "Propon." },
  { id: "imovel", label: "Imóvel", mobileLabel: "Imóvel" },
  { id: "pagamentos", label: "Pagamentos", mobileLabel: "Pagto." },
  { id: "resumo", label: "Resumo", mobileLabel: "Resumo" },
];

interface PropostaTabsProps {
  activeTab: PropostaTab;
  onTabChange: (tab: PropostaTab) => void;
}

export default function PropostaTabs({
  activeTab,
  onTabChange,
}: PropostaTabsProps) {
  const { isDark } = usePropostaForm();

  return (
    <div
      className={`grid grid-cols-4 w-full border-b mb-3 sm:mb-4 shrink-0 ${
        isDark ? "border-gray-700" : "border-gray-200"
      }`}
      role="tablist"
    >
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={activeTab === tab.id}
          aria-label={tab.label}
          onClick={() => onTabChange(tab.id)}
          className={`min-w-0 px-0.5 sm:px-5 py-2 sm:py-2.5 text-[11px] sm:text-sm font-semibold border-b-2 transition -mb-px rounded-none text-center leading-tight ${
            activeTab === tab.id
              ? "border-primary text-primary"
              : isDark
                ? "border-transparent text-gray-400 hover:text-primary"
                : "border-transparent text-gray-500 hover:text-primary"
          }`}
        >
          <span className="sm:hidden">{tab.mobileLabel}</span>
          <span className="hidden sm:inline">{tab.label}</span>
        </button>
      ))}
    </div>
  );
}
